import {productDetailsSettings, ProductDetailsSettings} from '../../../bps/components/productDetails/productDetailsSettings';

productDetailsSettings.flags.src.awardInSetImage = '/assets/hawesko/frontend-core/staticImages/awardInSet.svg';
productDetailsSettings.flags.src.boxSetImage = '/assets/hawesko/frontend-core/staticImages/wood-box.png';
productDetailsSettings.flags.whitelist = ['new', 'newVintage', 'stoerer', 'free', 'savings', 'award', 'awardInSet', 'boxSetLayer'];

export {productDetailsSettings, ProductDetailsSettings};
